import { api } from 'boot/axios'
import m from 'moment'

const today = m().format('YYYY-MM-DD')
const getParams = officeId => ({
  params: {
    officeId,
    paymentTypes: ['C', 'A', 'P'],
    from: m().subtract(1, 'day').format('YYYY-MM-DD'),
    to: today,
  },
})

export default {
  namespaced: true,

  state: {
    loading: false,
    icons: {
      Receipt: 'mdi-cash-register',
      Invoice: 'mdi-file-document',
      InvoiceFee: 'mdi-cash-multiple',
      RepairFee: 'mdi-hammer-screwdriver',
      OrderFee: 'mdi-cart',
    },

    officeId: null,

    current: null,
    expense: null,
    refund: null,
    list: [],
  },

  getters: {
    groupByType: ({ list }) => list.reduce((t, { type }) => {
      t[type] = (t[type] || 0) + 1
      return t
    }, {}),
  },

  actions: {
    async refresh({ commit, state: { officeId } }) {
      commit('SET_LOADING', true)
      const {
        data: {
          [today]: { currents, expenses, refunds, list } = {},
        } = {},
      } = await api.get('cash', getParams(officeId))

      commit('SET_VALUES', { currents, expenses, refunds, list })
      commit('SET_LOADING', false)
    },
  },

  mutations: {
    SET_LOADING(state, loading) { state.loading = loading },
    SET_OFFICE_ID(state, officeId) { state.officeId = officeId },
    SET_VALUES(state, { currents, expenses, refunds, list }) {
      state.current = currents ? Object.values(currents).reduce((t, v) => t + v, 0) : null
      state.expense = expenses ? Object.values(expenses).reduce((t, v) => t + v, 0) : null
      state.refund = refunds ? Object.values(refunds).reduce((t, v) => t + v, 0) : null
      state.list = list || []
    },
  },
}
